import { Tab, Tabs, Tooltip } from "@mui/material";
import { blue } from "@mui/material/colors";

import {
  Inbox,
  CloudUpload,
  Assessment,
  Business,
  Label,
  ListAlt,
} from "@mui/icons-material";
import { useLocation, useNavigate, useRouteLoaderData } from "react-router-dom";

const routes = [
  {
    route: "/inbox",
    name: "Inbox",
    icon: <Inbox fontSize="small" />,
  },
  {
    route: "/reports",
    name: "Reports",
    icon: <Assessment fontSize="small" />,
  },
  {
    route: "/corporations",
    name: "Corporations",
    icon: <Business fontSize="small" />,
  },
  {
    route: "/labels",
    name: "Labels",
    icon: <Label fontSize="small" />,
  },
  {
    route: "/line_items",
    name: "Line Items",
    icon: <ListAlt fontSize="small" />,
  },
];

const Sidebar = () => {
  const navigation = useNavigate();
  const location = useLocation();
  const { authID } = useRouteLoaderData("authentication-context");
  return (
    <Tabs
      orientation="vertical"
      onChange={(_, v) => navigation(`${v}?authID=${authID}`)}
      value={location.pathname}
    >
      {routes.map((route) => (
        <Tab
          key={route.route}
          value={route.route}
          icon={
            <Tooltip title={route.name} arrow placement="right-end">
              {route.icon}
            </Tooltip>
          }
        />
      ))}
    </Tabs>
  );
};

export default Sidebar;
